import React from 'react'
import {Table, Thead, Th, Tr, Td} from 'reactable'
import '../../css/tables/reactable.css'
import '../../css/ui-elements/buttons.css'
import TableFilters from './TableFilters'

const DefaultTable = ({
  items,
  columns,
  columnNames,
  itemsPerPage,
  searchable,
  search,
  onSearch,
  filterable,
  filter,
  onFilter,
  onChangeItemsPerPage,
  openBtnVisible,
  openBtnLabel,
  onClickOpenBtn,
  openBtnHref,
  pushBtnLabel,
  pushBtnFn,
  sortable,
  defaultSort,
  hiddenColumns,
  hiddenSelectItemsPerPage,
  selectPerPageCss
}) => {
  if (!sortable && sortable !== false) {
    sortable = true;
  }

  if (!defaultSort) {
    defaultSort = false;
  }

  function getFiltersList(filterable){
    if(filterable.filters === 'auto'){
      var uniqueFilterItems = new Set();
      items.forEach(item => {
        uniqueFilterItems.add(item[filterable.column])
      });
      return Array.from(uniqueFilterItems).map(filter => {
        return {
          value: filter.toLowerCase(),
          label: filter
        }
      });
    }
    return filterable.filters;
  }

  function getColumnValueAsText(column){
    if(typeof(column) === 'object'){
      if(column.props.status){
        return column.props.status;
      }
    }
    return column.toLowerCase();
  }

  function filterRow(item){
    return filterable.map(function(element){
      var filterText = filter[element.column];
      return filterText.length === 0 || getColumnValueAsText(item[element.column]) === filterText;
    }).every(function(match){
      return match;
    });
  }

  function onFilterAgregate(filterText, columnName){
    filter[columnName] = filterText;
    onFilter(filter);
  }

  return (
    <div>
      <div className="row d-flex">
        <div className="col-12 col-md-3">
          {searchable.length > 0 &&
            <form onSubmit={e => e.preventDefault()}>
              <div className="form-group">
                <div className="input-group">
                  <input className="form-control grid-search-input" type="text" value={search} onChange={onSearch} />
                  <span className="input-group-addon grid-search-icon">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </form>
          }
        </div>
        <div className={`col-11 ${searchable.length > 0  ? 'col-md-8':''}`}>
          {filterable.map((element, i) => (
            <TableFilters key={i} items={getFiltersList(element)} filter={filter[element.column]} onFilter={onFilterAgregate} name={element.column}/>
          ))}
        </div>
        <div className="col-1">
          <form onSubmit={e => e.preventDefault()} className="pull-right">
            <div className="form-group form-inline" style={{marginTop:selectPerPageCss?selectPerPageCss:''}}>
            {!hiddenSelectItemsPerPage &&
              <select className="custom-select grid-select-items-per-page" onChange={onChangeItemsPerPage} value={itemsPerPage}>
                <option value="10">10 rows</option>
                <option value="20">20 rows</option>
                <option value="50">50 rows</option>
                <option value="100">100 rows</option>
              </select>
            }
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Table
            className="table table-striped"
            itemsPerPage={itemsPerPage}
            pageButtonLimit={5}
            sortable={sortable}
            defaultSort={defaultSort}
            filterable={searchable}
            hideFilterInput
            filterBy={search}
            noDataText="No matching records found">
            <Thead>
              {columns.map((column, i) => (
                <Th key={i} column={column} className={hiddenColumns.includes(column) ? 'hiddenColumns' : ''}>
                  {columnNames[i]}
                </Th>
              ))}
              <Th key="editColumn" column="Edit">&nbsp;</Th>
            </Thead>
            {items.map((item, i) => (
              filterRow(item) &&
              <Tr key={i + '1'}>
                {columns.map((column, j) => (
                  <Td key={j} column={column} data={item[column]} className={hiddenColumns.includes(column) ? 'hiddenColumns' : ''}>
                    <span>{item[column]}</span>
                  </Td>
                ))}

                {/* Can hide button generally or for selected items */}
                {openBtnVisible && item.openBtnVisible !== false && onClickOpenBtn &&
                  <Td key="editBtnColumn" column="Edit">
                    <button className="btn btn-rounded btn-primary"
                      onClick={(e) => onClickOpenBtn(item['NavigationParam'], e)}>
                      {openBtnLabel}
                    </button>
                  </Td>
                }
                {openBtnVisible && item.openBtnVisible !== false && openBtnHref &&
                  <Td key="editBtnColumn" column="Edit">

                    {pushBtnLabel && item.Status && item.Status.props.status == 'draft' ?
                      <>
                        <a className="btn btn-rounded btn-primary mr-2 text-white" role="button" onClick={() => pushBtnFn(item['NavigationParam'])}>
                          {pushBtnLabel}
                        </a>
                        <a className="btn btn-rounded btn-primary" role="button" href={openBtnHref.replace('{NavigationParam}', item['NavigationParam'])}>
                          {openBtnLabel}
                        </a>
                        </>
                      :
                      <>
                        <a className="btn btn-rounded btn-primary" role="button" href={openBtnHref.replace('{NavigationParam}', item['NavigationParam'])}>
                          {openBtnLabel}
                        </a>
                      </>
                    }
                  </Td>
                }
              </Tr>
            ))
          }
          </Table>
        </div>
      </div>
    </div>
  )
}
DefaultTable.defaultProps = {
  items: [],
  columns: [],
  itemsPerPage: 20,
  hiddenColumns: [],
  filterable: [],
  filter: '',
  searchable: []
}
export default DefaultTable
